import { render, staticRenderFns } from "./PostDouble1000Arm1976-F.vue?vue&type=template&id=f327ed36"
import script from "./PostDouble1000Arm1976-F.vue?vue&type=script&lang=js"
export * from "./PostDouble1000Arm1976-F.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports